module.exports = "https://static.wmbcdn.com/uniweb/images/9045168edd89ae23385a873fd0a136c5.svg";